export default "__VITE_ASSET__xiPk1e0b__"